import ApiBase from './ApiBase'
import {IdResponse, PlaySessionResult, StartSessionResponse} from '../model/models'
import ApiResponse from '../model/ApiResponse'

export default class PlayApi extends ApiBase {
  async startSession(deckId: number): Promise<ApiResponse<StartSessionResponse | null>> {
    return await this.post<StartSessionResponse>(`play/start-session`, {deckId})
  }

  // Returns SessionCard Id needed for updateCard request
  async startCard(sessionId: number, deckId: number, cardId: number): Promise<ApiResponse<IdResponse | null>> {
    return await this.post<IdResponse>('play/start-card', {sessionId, deckId, cardId})
  }

  async updateCard(sessionId: number, sessionCardId: number, deckId: number, cardId: number, known: boolean): Promise<ApiResponse<any>> {
    return await this.post('play/update-card', {sessionId, sessionCardId, deckId, cardId, known})
  }

  async finishSession(sessionId: number): Promise<ApiResponse<PlaySessionResult | null>> {
    return await this.post(`play/finish-session/${sessionId}`, {})
  }
}
